import capacityReducer, { capacityApi } from '@reducers/capacity/capacity';
import didGroupsReducer, { didGroupsApi } from '@reducers/capacity/didgroups';

export { capacityApi } from '@reducers/capacity/capacity';
export { didGroupsApi } from '@reducers/capacity/didgroups';

export const capacityMiddlewares = [
  capacityApi.middleware,
  didGroupsApi.middleware,
];
export const capacityReducers = {
  capacity: capacityReducer,
  didGroups: didGroupsReducer,
  [capacityApi.reducerPath]: capacityApi.reducer,
  [didGroupsApi.reducerPath]: didGroupsApi.reducer,
};
